import React, { useEffect, useState } from "react";
import AudioMessagePlayer from "../../components/AudioMessagePlayer";

const resolveAudioUrl = (message) => {
  if (message?.media_url) {
    return message.media_url;
  }
  const text = String(message?.text || "");
  if (/^https?:\/\//i.test(text)) {
    return text;
  }
  return null;
};

const IncomingAudioMessage = ({
  message,
  isOutgoing = false,
  isFetching = false,
  isDownloading = false,
  onFetchMedia,
  onDownload,
}) => {
  const [src, setSrc] = useState(() => resolveAudioUrl(message));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSrc(resolveAudioUrl(message));
  }, [message]);

  const loadMedia = async () => {
    if (src || !onFetchMedia || loading) {
      return;
    }

    setLoading(true);
    try {
      const url = await onFetchMedia(message);
      if (url) {
        setSrc(url);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOutgoing && !src && message?.media_id) {
      loadMedia();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message?.id, message?.media_id, isOutgoing]);

  return (
    <AudioMessagePlayer
      src={src}
      isOutgoing={isOutgoing}
      loading={loading || isFetching}
      isDownloading={isDownloading}
      onRequestLoad={loadMedia}
      onDownload={!isOutgoing ? onDownload : undefined}
    />
  );
};

export default IncomingAudioMessage;
